import {Network} from "../../../utils/network";
import {rewardsActionTypes} from "./rewards.actionTypes";

export const getRewardsDetails = () => async (dispatch, state) => {
  try {
    const res = await Network.getSmileCoinsDetails();
    dispatch({
      type: rewardsActionTypes.SET_REWARDS_DETAILS_SUCCESS,
      payload: res?.data,
    });
  } catch (e) {
    dispatch({
      type: rewardsActionTypes.SET_REWARDS_DETAILS_ERROR,
      payload: e?.response,
    });
  }
};

export const getGamificationDetails = () => async (dispatch, state) => {
  try {
    const res = await Network.getRewardDetail();
    dispatch({
      type: rewardsActionTypes.GAMIFICATION_DETAIL_SUCCESS,
      payload: res?.data,
    });
  } catch (e) {
    dispatch({
      type: rewardsActionTypes.GAMIFICATION_DETAIL_ERROR,
      payload: e?.response,
    });
  }
};

export const getLuckyCoinEvents = () => {
  return async (dispatch, state) => {
    try {
      dispatch({
        type: rewardsActionTypes.REWARD_EVENT_LOADING,
      });
      const res = await Network.getProbes({probe_type: "promo"});

      dispatch({
        type: rewardsActionTypes.REWARD_EVENT_SUCCESS,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: rewardsActionTypes.REWARD_EVENT_ERROR,
      });
    }
  };
};

export const getRewardsMainDetails = () => async (dispatch, state) => {
  try {
    const res = await Network.getTokenSummary();
    dispatch({
      type: rewardsActionTypes.REWARDS_DETAILS_SUCCESS,
      payload: res?.data,
    });
  } catch (e) {
    dispatch({
      type: rewardsActionTypes.REWARDS_DETAILS_ERROR,
      payload: e?.response,
    });
  }
};

export const getMMDetails = () => async (dispatch, state) => {
  try {
    dispatch({
      type: rewardsActionTypes.MM_DETAILS_LOADING,
    });
    const res = await Network.getMarketMaking();
    dispatch({
      type: rewardsActionTypes.MM_DETAILS_SUCCESS,
      payload: res?.data,
    });
  } catch (e) {
    dispatch({
      type: rewardsActionTypes.MM_DETAILS_ERROR,
      payload: e?.response,
    });
  }
};
